import React from "react";
import { useTranslation } from "react-i18next";
import type { UsageSplit } from "@models/adminMonitoring";
import { AdminTable, col } from "@components/AdminTable";
import { formatCount, formatQuantities } from "@utils/monitoringFormat";

/** A transaction's cost per value of one tag: its pipeline steps, its items, its resources. */
const UsageSplitTable: React.FC<{ rows: UsageSplit[]; header: string }> = ({ rows, header }) => {
  const { t } = useTranslation();
  const columns = [
    col.text<UsageSplit>("value", header, (r) => r.value, { mono: true }),
    col.number<UsageSplit>("events", t("admin.insights.columns.events"), (r) => r.event_count),
    col.text<UsageSplit>("tokens", t("admin.insights.columns.tokens"),
      (r) => (r.input_tokens || r.output_tokens ? `${formatCount(r.input_tokens)} / ${formatCount(r.output_tokens)}` : "-")),
    col.text<UsageSplit>("quantities", t("admin.insights.columns.quantities"), (r) => formatQuantities(r.quantities)),
    col.money<UsageSplit>("cost", t("admin.insights.columns.cost"), (r) => ({
      amount: r.total_cost, currency: r.currency, warn: r.unpriced_count > 0,
      note: r.unpriced_count > 0 ? t("admin.insights.unpricedBadge", { count: r.unpriced_count }) : undefined,
    })),
  ];
  return <AdminTable columns={columns} data={rows} getRowKey={(r) => `${r.value}-${r.currency}`} />;
};

export default UsageSplitTable;
